<template>
    <div class="empresa container">
        <div class="row">
            <div class="empresa-chamada col-md-12">
                    <h3>conocer nuestra</h3>
                    <h2>historia</h2>
                </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <img :src="empresaImage" alt="">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <p>
                    La familia Funada inició su historia en Brasil en 1931, cuando Mampei y Kimi Funada dejaron a Japón con sus hijos para el comienzo de una historia de éxito en Brasil.
                </p>
                <p>    
                    Fue el 15 de septiembre de 1947 que la Familia Funada dio un paso importante en la construcción de lo que sería uno de los mayores emprendimientos de la historia de la familia y que cambiaría el contexto socioeconómico de Presidente Prudente.
                </p>
                <p>
                    En principio, la industria familiar era conocida como "Funada e Hijos", cuando producía diversos ítems como: guaraná, soda limonada, agua tónica, jarabes, coñac, aguardiente, quinado, raíz amarga y vinagre.  
                </p>
                <p>
                    Entre las décadas de 50 y 60 ocurrieron grandes cambios, el emprendimiento pasó a recibir el nombre: "Industria y Comercio de Bebidas Funada". Este período fue marcado principalmente por la adquisición de modernos aparatos, que permitieron la ampliación de la producción y la especialización en la fabricación de refrescos.
                </p>
                <p>
                    En todos estos años, la "Industria de Bebidas Funada" siempre priorizó el respeto y la confianza de los clientes, buscando mejorar la calidad de sus productos que pasaron a conquistar nuevos mercados con los sabores: Tubaina, Guaraná, Naranja, Limón, RefriCola, Uva Funada y el Guaraná Funada Light.
                </p>
                <p>
                    La Funada siempre ha realizado una búsqueda continua de nuevas tendencias y tecnologías, a través del programa "Calidad Total". Los resultados son productos de altísima calidad que acompañan los anhelos del mercado, como la actual línea "Life-Up" en la categoría agua saborizada, sin adición de azúcar y con jugos naturales de limón y mandarina.
                </p>
                <p>
                    Todos los productos Funada buscan valorar la salud y la calidad de vida de los consumidores. Con destaque para el diseño moderno de los nuevos embalajes P.E.T. confeccionadas para conquistar el mercado.
                </p>
                <p>
                    Actualmente, la Funada está presente en diversos Estados, entre ellos: São Paulo, Paraná y Mato Grosso del Sur, además de los países: Paraguay, Bolivia y Japón.
                </p>

                <div role="tablist">
                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion1 variant="info">Proceso de Producción</b-btn>
                        </b-card-header>
                        <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <p class="card-text">
                                    "Hacer los refrigerantes Funada es más que producir simplemente una bebida. Es producir alegrías. Es hacer parte de momentos de satisfacción ". La empresa dedica esfuerzos diarios en la línea de producción de las bebidas. Son, en promedio, 165 mil litros por día, sumándose a Presidente Prudente y Campo Grande.
                                </p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion2 variant="info">Calidad Total</b-btn>
                        </b-card-header>
                        <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                            <p class="card-text">
                                {{ text }}
                            </p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion3 variant="info">Flota</b-btn>
                        </b-card-header>
                        <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                            <p class="card-text">
                                {{ text }}
                            </p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      empresaImage: require("../assets/empresa.png"),
      empresa: true,
      empresaChamada: true,
      text: "nada!"
    }
  }
}
</script>

<style scoped>
.empresa {
  padding-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 50px;
}

.empresa-image {
  height: 100%;
}

.empresa-chamada {
  padding-bottom: 30px;
}

.empresa img {
  width: 100%;
  padding: 8%;
  /* position: absolute; */
  margin-top: 10%;
}

.empresa h2 {
  font-family: "Bambino";
  font-style: normal;
  font-size: 15pt;
  text-transform: uppercase;
}

.empresa h3 {
  font-family: "Bambino";
  font-style: normal;
  font-size: 10pt;
  text-transform: uppercase;
  font-weight: 300;
}

.empresa p {
  font-family: "Bambino";
  font-style: normal;
  font-size: 9pt;
  /* text-transform: uppercase; */
  font-weight: 400;
  text-align: justify;
}

.btn-info {
  color: #000;
  background-color: transparent;
  border-color: #000000;
}

.btn-info:focus,
:active {
  color: #000;
  background-color: transparent;
  border-color: #000000;
}

.btn {
  border-radius: 0px;
  font-family: "Bambino";
  text-transform: uppercase;
  font-weight: 400;
  text-align: left;
}

.card-header {
  border-bottom: 0px solid rgba(0, 0, 0, 0);
}

.btn-info:not(:disabled):not(.disabled):active,
.btn-info:not(:disabled):not(.disabled).active,
.show > .btn-info.dropdown-toggle {
  color: #000;
  background-color: transparent;
  border-color: transparent;
  -webkit-box-shadow: 0 0 0 0rem transparent;
  box-shadow: 0 0 0 0rem transparent;
}

.btn-info:focus,
.btn-info.focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0);
  box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0);
}

.card {
  border-radius: 0px;
}

@media only screen and (min-width: 320px) and (max-width: 1024px) {
  .empresa {
    padding-left: 20px;
    padding-right: 20px;
  }

  .empresa img {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Empresa.vue